import { render, staticRenderFns } from "./WrinklesTemplate.vue?vue&type=template&id=6654ca49"
import script from "./WrinklesTemplate.vue?vue&type=script&lang=js"
export * from "./WrinklesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports